import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ExperimentalFeatureDef, ExperimentalFeaturesService } from '../../services/experimental-features.service';

@Component({
  selector: 'app-experimental-features-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './experimental-features-panel.component.html',
  styleUrl: './experimental-features-panel.component.scss'
})
export class ExperimentalFeaturesPanelComponent implements OnInit {
  @Output() close = new EventEmitter<void>();

  constructor(public experimentalFeatures: ExperimentalFeaturesService) {}

  // Only the experiments this user could actually see the effect of: an experiment layered on a
  // feature permission they don't hold is hidden, not disabled.
  get features(): ExperimentalFeatureDef[] {
    return this.experimentalFeatures.visibleFeatures;
  }

  // The panel is created on open (*ngIf in the sidebar), so this re-reads the flags exactly when
  // the user is about to look at them — covering a toggle made in another tab or on another device.
  ngOnInit(): void {
    this.experimentalFeatures.refresh();
  }

  toggleFeature(id: string): void {
    this.experimentalFeatures.setEnabled(id, !this.experimentalFeatures.isEnabled(id));
  }

  closeModal(): void {
    this.close.emit();
  }
}
